/*
 * Generated by tutor-mfe for all.
 *
 * Frontend-base counterpart of the legacy env.config.jsx.
 */

import { getAuthenticatedUser as getConverterAuthenticatedUser } from '@edx/frontend-platform/auth';
import CourseConverterPage from './plugins/course-converter/CourseConverterPage';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient, getAuthenticatedUser } from '@edx/frontend-platform/auth';
import {
  AvatarButton,
  Badge,
  Button,
  Card,
  CardGrid,
  Container,
  Dropdown,
  Hyperlink,
  Icon,
  Image,
  Nav,
  Navbar,
  breakpoints,
  useMediaQuery,
  useWindowSize,
} from '@openedx/paragon';
import {
  ArrowForward,
  BookOpen,
  CheckCircleOutline,
  Search,
} from '@openedx/paragon/icons';
import { defineMessages, useIntl } from '@edx/frontend-platform/i18n';
import { PluginSlot } from '@openedx/frontend-plugin-framework';

import { DIRECT_PLUGIN, IFRAME_PLUGIN, PLUGIN_OPERATIONS } from '@openedx/frontend-plugin-framework';

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }
  config.pluginSlots[slot_name].plugins.push(...plugins);
}
let themeVariant = 'selected-paragon-theme-variant';

const AddDarkTheme = () => {
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  const addDarkThemeToIframes = () => {
    const iframes = document.getElementsByTagName('iframe');
    const iframesLength = iframes.length;
    if (iframesLength > 0) {
      Array.from({ length: iframesLength }).forEach((_, index) => {
        const style = document.createElement('style');
        style.textContent = `
          body {
            background-color: #0D0D0E;
            color: #ccc;
          }
          a { color: #ccc; }
          a:hover { color: #d3d3d3; }
        `;
        if (iframes[index].contentDocument) {
          iframes[index].contentDocument.head.appendChild(style);
        }
      });
    }
  };

  useEffect(() => {
    const theme = window.localStorage.getItem(themeVariant);

    // - When page loads, Footer loads before MFE content. Since there is no iframe on page,
    // it does not append any class. MutationObserver observes changes in DOM and hence appends dark
    // attributes when iframe is added. After 15 sec, this observer is destroyed to conserve resources. 
    // - It has been added outside dark-theme condition so that it can be removed on Component Unmount.
    // - Observer can be passed to `addDarkThemeToIframes` function and disconnected after observing Iframe.
    // This approach has a limitation: the observer first detects the iframe and then detects the docSrc. 
    // We need to wait for docSrc to fully load before appending the style tag.
    const observer = new MutationObserver(() => {
      addDarkThemeToIframes();
    });

    if (isThemeToggleEnabled && theme === 'dark') {
      document.documentElement.setAttribute('data-paragon-theme-variant', 'dark');

      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer?.disconnect(), 15000); // clear after 15 sec to avoid resource usage
    }

    return () => observer?.disconnect();
  }, []);

  return (<div />);
};class LoadGoogleTagManager {
  gtmId = '';

  gtmEnvironment = '';

  constructor({ config }) {
    this.gtmId = config.GOOGLE_TAG_MANAGER_ID;
    this.gtmEnvironment = config.GOOGLE_TAG_MANAGER_ENVIRONMENT || '';
  }

  loadScript() {
    if (!this.gtmId || document.getElementById('indigo-google-tag-manager')) {
      return;
    }

    const environment = this.gtmEnvironment
      && !this.gtmEnvironment.startsWith('&')
      ? `&${this.gtmEnvironment}`
      : this.gtmEnvironment;

    const dataLayer = Reflect.get(window, 'dataLayer') || [];
    Reflect.set(window, 'dataLayer', dataLayer);

    const gtag = Reflect.get(window, 'gtag') || function gtag() {
      dataLayer.push(arguments);
    };
    Reflect.set(window, 'gtag', gtag);
    gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      functionality_storage: 'granted',
      personalization_storage: 'denied',
      security_storage: 'granted',
    });

    dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.id = 'indigo-google-tag-manager';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmId}${environment}`;
    document.head.appendChild(script);
  }
}

function setConfig() {
  const config = {
    pluginSlots: {},
  };const footerMessages = defineMessages({
  logoAltText: {
    id: 'footer.logo.altText',
    defaultMessage: 'Powered by Open edX',
    description: 'Alt text for the footer logo.',
  },
  about: {
    id: 'footer.edxLinks.about',
    defaultMessage: 'About Us',
    description: 'Label for the About Us footer link.',
  },
  blog: {
    id: 'footer.connectLinks.blog',
    defaultMessage: 'Blog',
    description: 'Label for the Blog footer link.',
  },
  donate: {
    id: 'footer.connectLinks.donate',
    defaultMessage: 'Donate',
    description: 'Label for the Donate footer link.',
  },
  termsOfService: {
    id: 'authoring.footer.termsOfService.link.label',
    defaultMessage: 'Terms of Service',
    description: 'Label for the Terms of Service footer link.',
  },
  privacyPolicy: {
    id: 'authoring.footer.privacyPolicy.link.label',
    defaultMessage: 'Privacy Policy',
    description: 'Label for the Privacy Policy footer link.',
  },
  help: {
    id: 'footer.connectLinks.help',
    defaultMessage: 'Help',
    description: 'Label for the Help footer link.',
  },
  contact: {
    id: 'footer.connectLinks.contact',
    defaultMessage: 'Contact Us',
    description: 'Label for the Contact Us footer link.',
  },
});

const indigoFooterNavLinks = [
  { message: footerMessages.about, url: '/about' },
  { message: footerMessages.blog, url: '/blog' },
  { message: footerMessages.donate, url: '/donate' },
  { message: footerMessages.termsOfService, url: '/tos' },
  { message: footerMessages.privacyPolicy, url: '/privacy' },
  { message: footerMessages.help, url: '/help' },
  { message: footerMessages.contact, url: '/contact' },
];

const Footer = () => {
  const intl = useIntl();
  const config = getConfig();

  return (
    <Container size='xl' className="wrapper wrapper-footer">
      <footer id="footer" className="tutor-container">
        <div className="footer-top">
          <nav
            className="nav-colophon"
            aria-label={intl.formatMessage({
              id: "footer.about.label",
              defaultMessage: "About",
              description: "footer navigation label",
            })}
          >
            <ol>
              <li className="footer-logo-item">
                <a href="https://open.edx.org" rel="noreferrer" target="_blank">
                  <img
                    className="footer-logo__image--light"
                    src={`${config.LMS_BASE_URL}/theming/asset/images/logo.png`}
                    alt={intl.formatMessage(footerMessages.logoAltText)}
                    width="79"
                  />
                <img
                    className="footer-logo__image--dark"
                    src={`${config.LMS_BASE_URL}/theming/asset/images/logo-white.png`}
                    alt={intl.formatMessage(footerMessages.logoAltText)}
                    width="79"
                  />
                </a>
              </li>
              {indigoFooterNavLinks.map((link) => (
                <li key={link.url}>
                    <Hyperlink variant='primary' destination={`${link.url.startsWith("http") ? link.url : config.LMS_BASE_URL + link.url}`}>
                        {intl.formatMessage(link.message)}
                    </Hyperlink>
                </li>
              ))}
            </ol>
          </nav>
        </div>
      </footer>
    </Container>
  );
};
const ThemedLogo = () => {
  const BASE_URL = getConfig().LMS_BASE_URL;
  const lightLogoUrl = `${BASE_URL}/static/indigo/images/header-logo.png`;
  const darkLogoUrl = `${BASE_URL}/static/indigo/images/header-logo-white.png`;

  return (
    <>
      <style>
        {`
          #root header .logo-image.logo-white {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root header .logo-image {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root header .logo-white {
            display: block;
          }
        `}
      </style>
      <a href={`${BASE_URL}/dashboard`} title="Open edX" className="logo">
        <img className="logo-image" src={lightLogoUrl} alt="Open edX" />
        <img className="logo-image logo-white" src={darkLogoUrl} alt="Open edX" />
      </a>
    </>
  );
};const indigoGetUrl = (baseUrl, path) => {
  if (!path || path.startsWith('http://') || path.startsWith('https://')) {
    return path || '';
  }

  return `${baseUrl || ''}${path}`;
};

const IndigoHeaderLogo = () => {
  const config = getConfig();
  const siteName = config.SITE_NAME || 'Open edX';
  const dashboardUrl = indigoGetUrl(config.LMS_BASE_URL, '/dashboard');
  const logoUrl = indigoGetUrl(config.LMS_BASE_URL, '/static/indigo/images/header-logo.png');
  const darkLogoUrl = indigoGetUrl(config.LMS_BASE_URL, '/static/indigo/images/header-logo-white.png');

  return (
    <a aria-label={siteName} href={dashboardUrl} className="header-logo">
      {logoUrl ? (
        <>
          <img alt={siteName} className="header-logo__image header-logo__image--light" src={logoUrl} />
          <img alt={siteName} className="header-logo__image header-logo__image--dark" src={darkLogoUrl} />
        </>
      ) : (
        <span>{siteName}</span>
      )}
    </a>
  );
};// Frontend-base renders its native notifications widgets in the shell. Legacy
// MFE runtime definitions replace this fallback with NotificationsTray.
let IndigoHeaderNotificationsSlot = () => null;const indigoHeaderNavigationMessages = defineMessages({
  dashboard: {
    id: 'header.user.menu.dashboard',
    defaultMessage: 'Dashboard',
    description: 'Link to the user dashboard.',
  },
  courses: {
    id: 'header.links.courses',
    defaultMessage: 'Courses',
    description: 'Link to the learner course dashboard.',
  },
});

const isCurrentPath = (currentPath, activePaths) => activePaths.some(
  (path) => currentPath === path || currentPath.startsWith(`${path}/`),
);

const IndigoHeaderNavigation = () => {
  const intl = useIntl();
  const config = getConfig();
  const items = [
    {
      id: 'Dashboard',
      href: indigoGetUrl(config.LMS_BASE_URL, '/learner-dashboard/'),
      content: intl.formatMessage(indigoHeaderNavigationMessages.dashboard),
      activePaths: ['/learner-dashboard'],
    },
    {
      id: 'Catalog',
      href: indigoGetUrl(config.LMS_BASE_URL, '/catalog/'),
      content: intl.formatMessage(indigoHeaderNavigationMessages.courses),
      activePaths: ['/catalog'],
    },
  ];
  const currentPath = window.location.pathname.toLowerCase();
  const activeKey = items.find(
    (item) => isCurrentPath(currentPath, item.activePaths),
  )?.id;
  const getItemKey = (item, index) => `${item.id || item.href || item.content}-${index}`;

  return (
    <Nav
      activeKey={activeKey}
      aria-label="Primary"
      as="nav"
      className="desktop-header__navigation"
      variant="pills"
    >
      {items.map((item, index) => (
        <Nav.Item key={getItemKey(item, index)}>
          <Nav.Link
            aria-current={activeKey === item.id ? 'page' : undefined}
            disabled={item.disabled}
            eventKey={item.id}
            href={item.href || ''}
          >
            {item.content}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};const desktopUserMenuSlotOptions = { mergeProps: true };

const IndigoDesktopUserMenuItems = ({ menu = [] }) => {
  const items = menu.flatMap(group => group.items || []);
  const getItemKey = (item, index) => `${index}-${typeof item.content === 'string' ? item.content : item.href || 'menu-item'}`;

  return items.map((item, index) => (
    <Dropdown.Item
      as="a"
      disabled={item.disabled}
      href={item.disabled ? undefined : item.href}
      key={getItemKey(item, index)}
      onClick={item.disabled ? undefined : item.onClick}
    >
      {item.content}
    </Dropdown.Item>
  ));
};

const DesktopUserMenuSlot = ({ menu = [] }) => (
  <PluginSlot
    id="org.openedx.frontend.layout.header_desktop_user_menu.v1"
    idAliases={['desktop_user_menu_slot']}
    slotOptions={desktopUserMenuSlotOptions}
  >
    <IndigoDesktopUserMenuItems menu={menu} />
  </PluginSlot>
);

const frontendBaseDesktopUserMenuSlotMap = {
  'org.openedx.frontend.layout.header_desktop_user_menu.v1': {
    sourceAliases: ['desktop_user_menu_slot'],
    targetSlotId: 'de.abstracttechnology.frontend.slot.header.desktopUserMenu.v1',
  },
};

const FrontendBaseDesktopUserMenuSlot = ({ menu = [] }) => (
  <PluginSlot
    id="org.openedx.frontend.layout.header_desktop_user_menu.v1"
    idAliases={['desktop_user_menu_slot']}
    slotMap={frontendBaseDesktopUserMenuSlotMap}
    slotOptions={desktopUserMenuSlotOptions}
  >
    <IndigoDesktopUserMenuItems menu={menu} />
  </PluginSlot>
);const indigoHeaderUserMenuMessages = defineMessages({
  profile: {
    id: 'header.menu.profile.label',
    defaultMessage: 'Profile',
    description: 'The text for the user menu Profile navigation link.',
  },
  account: {
    id: 'header.menu.account.label',
    defaultMessage: 'Account',
    description: 'The text for the user menu Account navigation link.',
  },
  logout: {
    id: 'header.user.menu.logout',
    defaultMessage: 'Logout',
    description: 'Logout link.',
  },
});

const IndigoHeaderUserMenu = ({ UserMenuSlot = DesktopUserMenuSlot }) => {
  const intl = useIntl();
  const authenticatedUser = getAuthenticatedUser();
  const config = getConfig();
  const username = authenticatedUser?.username || 'Account';
  const [avatarUrl, setAvatarUrl] = React.useState();

  useEffect(() => {
    if (!authenticatedUser?.username) {
      return undefined;
    }

    let isMounted = true;

    getAuthenticatedHttpClient()
      .get(`${config.LMS_BASE_URL}/api/user/v1/accounts/${authenticatedUser.username}`)
      .then(({ data }) => {
        const profileImage = data.profile_image || data.profileImage;
        const imageUrl = profileImage?.has_image || profileImage?.hasImage
          ? profileImage.image_url_medium
            || profileImage.imageUrlMedium
            || profileImage.image_url_small
            || profileImage.imageUrlSmall
            || profileImage.image_url_full
            || profileImage.imageUrlFull
          : undefined;

        if (isMounted) {
          setAvatarUrl(imageUrl);
        }
      })
      .catch(() => {
        // Keep Paragon's default avatar when the profile image cannot be loaded.
      });

    return () => {
      isMounted = false;
    };
  }, [authenticatedUser?.username, config.LMS_BASE_URL]);

  const items = [
    {
      type: 'item',
      content: intl.formatMessage(indigoHeaderUserMenuMessages.profile),
      href: `${config.ACCOUNT_PROFILE_URL}/u/${username}`,
    },
    {
      type: 'item',
      content: intl.formatMessage(indigoHeaderUserMenuMessages.account),
      href: config.ACCOUNT_SETTINGS_URL,
    },
    {
      type: 'item',
      content: intl.formatMessage(indigoHeaderUserMenuMessages.logout),
      href: config.LOGOUT_URL,
    },
  ];
  return (
    <Dropdown alignRight>
      <Dropdown.Toggle
        as={AvatarButton}
        aria-label={username}
        bsPrefix="pgn__dropdown-toggle-iconbutton"
        id="desktop-header-user-menu"
        showLabel={false}
        size="lg"
        src={avatarUrl}
      >
        {username}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <UserMenuSlot menu={[{ items }]} />
      </Dropdown.Menu>
    </Dropdown>
  );
};const desktopSecondaryMenuSlotOptions = { mergeProps: true };

const IndigoDesktopSecondaryMenuItems = ({ menu = [] }) => (
  Array.isArray(menu) ? menu.map((item, index) => (
    <Nav.Link
      disabled={item.disabled}
      href={item.disabled ? undefined : item.href}
      key={item.id || item.href || index}
      onClick={item.disabled ? undefined : item.onClick}
    >
      {item.content}
    </Nav.Link>
  )) : menu
);

const DesktopSecondaryMenuSlot = ({ menu = [] }) => (
  // Extension point used by plugins such as the Open edX multilanguage selector:
  // https://gitlab.com/abstract-germany/plugins/openedx-multilanguage-selector
  <PluginSlot
    id="org.openedx.frontend.layout.header_desktop_secondary_menu.v2"
    idAliases={[
      'org.openedx.frontend.layout.header_desktop_secondary_menu.v1',
      'desktop_secondary_menu_slot',
    ]}
    slotOptions={desktopSecondaryMenuSlotOptions}
  >
    <IndigoDesktopSecondaryMenuItems menu={menu} />
  </PluginSlot>
);

const frontendBaseDesktopSecondaryMenuSlotMap = {
  'org.openedx.frontend.layout.header_desktop_secondary_menu.v2': {
    sourceAliases: [
      'org.openedx.frontend.layout.header_desktop_secondary_menu.v1',
      'desktop_secondary_menu_slot',
    ],
    targetSlotId: 'de.abstracttechnology.frontend.slot.header.desktopSecondaryMenu.v1',
  },
};

const FrontendBaseDesktopSecondaryMenuSlot = ({ menu = [] }) => (
  <PluginSlot
    id="org.openedx.frontend.layout.header_desktop_secondary_menu.v2"
    idAliases={[
      'org.openedx.frontend.layout.header_desktop_secondary_menu.v1',
      'desktop_secondary_menu_slot',
    ]}
    slotMap={frontendBaseDesktopSecondaryMenuSlotMap}
    slotOptions={desktopSecondaryMenuSlotOptions}
  >
    <IndigoDesktopSecondaryMenuItems menu={menu} />
  </PluginSlot>
);const IndigoAuthenticatedHeader = ({
  NotificationsSlot = IndigoHeaderNotificationsSlot,
  SecondaryMenuSlot = DesktopSecondaryMenuSlot,
  UserMenuSlot = DesktopUserMenuSlot,
}) => (
  <div className="desktop-header__authenticated-header">
    <div className="desktop-header__authenticated-header_left">
      <IndigoHeaderLogo />
      <IndigoHeaderNavigation />
    </div>
    <div className="desktop-header__authenticated-header_right">
      <SecondaryMenuSlot />
      <NotificationsSlot />
      <IndigoHeaderUserMenu UserMenuSlot={UserMenuSlot} />
    </div>
  </div>
);const indigoNotAuthenticatedHeaderMessages = defineMessages({
  register: {
    id: 'general.register.sentenceCase',
    defaultMessage: 'Register',
    description: 'Text in a button, prompting the user to register.',
  },
  signIn: {
    id: 'general.signIn.sentenceCase',
    defaultMessage: 'Sign in',
    description: 'Text in a button, prompting the user to log in.',
  },
});

const IndigoNotAuthenticatedHeader = ({ SecondaryMenuSlot = DesktopSecondaryMenuSlot }) => {
  const intl = useIntl();
  const config = getConfig();
  const signInUrl = config.LOGIN_URL || indigoGetUrl(config.LMS_BASE_URL, '/login');
  const registerUrl = indigoGetUrl(config.LMS_BASE_URL, '/register');

  return (
    <div className="desktop-header__not-authenticated-header">
      <IndigoHeaderLogo />
      <div className="desktop-header__not-authenticated-header_actions">
        <SecondaryMenuSlot />
        <Nav aria-label="Account" as="nav">
          <Nav.Item>
            <Nav.Link href={signInUrl || ''}>
              <Button as="span" variant="outline-primary">
                {intl.formatMessage(indigoNotAuthenticatedHeaderMessages.signIn)}
              </Button>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href={registerUrl || ''}>
              <Button as="span">
                {intl.formatMessage(indigoNotAuthenticatedHeaderMessages.register)}
              </Button>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
    </div>
  );
};const IndigoDesktopHeader = ({
  isLoggedIn,
  NotificationsSlot = IndigoHeaderNotificationsSlot,
  SecondaryMenuSlot = DesktopSecondaryMenuSlot,
  UserMenuSlot = DesktopUserMenuSlot,
}) => (
  <div className="desktop-header-wrapper">
    <div className="desktop-header__background" />
    <Container className="desktop-header" fluid size="xl">
      {isLoggedIn ? (
        <IndigoAuthenticatedHeader
          SecondaryMenuSlot={SecondaryMenuSlot}
          NotificationsSlot={NotificationsSlot}
          UserMenuSlot={UserMenuSlot}
        />
      ) : (
        <IndigoNotAuthenticatedHeader SecondaryMenuSlot={SecondaryMenuSlot} />
      )}
    </Container>
  </div>
);const mobileSecondaryMenuSlotOptions = { mergeProps: true };

const IndigoMobileSecondaryMenuItems = ({ menu = [] }) => (
  Array.isArray(menu) ? menu.map((item, index) => (
    <Nav.Link
      disabled={item.disabled}
      href={item.disabled ? undefined : item.href}
      key={item.id || item.href || index}
      onClick={item.disabled ? undefined : item.onClick}
    >
      {item.content}
    </Nav.Link>
  )) : menu
);

const MobileSecondaryMenuSlot = ({ menu = [] }) => (
  // Extension point used by plugins such as the Open edX multilanguage selector:
  // https://gitlab.com/abstract-germany/plugins/openedx-multilanguage-selector
  <PluginSlot
    id="org.openedx.frontend.layout.header_mobile_main_menu.v1"
    idAliases={['mobile_main_menu_slot']}
    slotOptions={mobileSecondaryMenuSlotOptions}
  >
    <IndigoMobileSecondaryMenuItems menu={menu} />
  </PluginSlot>
);

const frontendBaseMobileSecondaryMenuSlotMap = {
  'org.openedx.frontend.layout.header_mobile_main_menu.v1': {
    sourceAliases: ['mobile_main_menu_slot'],
    targetSlotId: 'de.abstracttechnology.frontend.slot.header.mobileMainMenu.v1',
  },
};

const FrontendBaseMobileSecondaryMenuSlot = ({ menu = [] }) => (
  <PluginSlot
    id="org.openedx.frontend.layout.header_mobile_main_menu.v1"
    idAliases={['mobile_main_menu_slot']}
    slotMap={frontendBaseMobileSecondaryMenuSlotMap}
    slotOptions={mobileSecondaryMenuSlotOptions}
  >
    <IndigoMobileSecondaryMenuItems menu={menu} />
  </PluginSlot>
);const mobileUserMenuSlotOptions = { mergeProps: true };

const IndigoMobileUserMenuItems = ({ menu = [] }) => {
  const items = menu.flatMap(group => group.items || []);
  const getItemKey = (item, index) => `${item.id || item.href || item.content}-${index}`;

  return items.map((item, index) => (
    <Nav.Item key={getItemKey(item, index)}>
      <Nav.Link href={item.href || ''}>
        {item.content}
      </Nav.Link>
    </Nav.Item>
  ));
};

const MobileUserMenuSlot = ({ menu = [] }) => (
  <PluginSlot
    id="org.openedx.frontend.layout.header_mobile_user_menu.v1"
    idAliases={['mobile_user_menu_slot']}
    slotOptions={mobileUserMenuSlotOptions}
  >
    <IndigoMobileUserMenuItems menu={menu} />
  </PluginSlot>
);

const frontendBaseMobileUserMenuSlotMap = {
  'org.openedx.frontend.layout.header_mobile_user_menu.v1': {
    sourceAliases: ['mobile_user_menu_slot'],
    targetSlotId: 'de.abstracttechnology.frontend.slot.header.mobileUserMenu.v1',
  },
};

const FrontendBaseMobileUserMenuSlot = ({ menu = [] }) => (
  <PluginSlot
    id="org.openedx.frontend.layout.header_mobile_user_menu.v1"
    idAliases={['mobile_user_menu_slot']}
    slotMap={frontendBaseMobileUserMenuSlotMap}
    slotOptions={mobileUserMenuSlotOptions}
  >
    <IndigoMobileUserMenuItems menu={menu} />
  </PluginSlot>
);const indigoMobileHeaderMessages = defineMessages({
  profile: {
    id: 'header.menu.profile.label',
    defaultMessage: 'Profile',
    description: 'The text for the user menu Profile navigation link.',
  },
  account: {
    id: 'header.menu.account.label',
    defaultMessage: 'Account',
    description: 'The text for the user menu Account navigation link.',
  },
  logout: {
    id: 'header.user.menu.logout',
    defaultMessage: 'Logout',
    description: 'Logout link.',
  },
  courses: {
    id: 'header.links.courses',
    defaultMessage: 'Courses',
    description: 'Link to the learner course dashboard.',
  },
  dashboard: {
    id: 'header.user.menu.dashboard',
    defaultMessage: 'Dashboard',
    description: 'Link to the user dashboard.',
  },
  register: {
    id: 'general.register.sentenceCase',
    defaultMessage: 'Register',
    description: 'Text in a link, prompting the user to register.',
  },
  signIn: {
    id: 'general.signIn.sentenceCase',
    defaultMessage: 'Sign in',
    description: 'Text in a link, prompting the user to log in.',
  },
});

const IndigoMobileHeader = ({
  isLoggedIn,
  username,
  NotificationsSlot = IndigoHeaderNotificationsSlot,
  SecondaryMenuSlot = MobileSecondaryMenuSlot,
  UserMenuSlot = MobileUserMenuSlot,
}) => {
  const intl = useIntl();
  const config = getConfig();
  const dashboardUrl = indigoGetUrl(config.LMS_BASE_URL, '/dashboard');
  const catalogUrl = indigoGetUrl(config.LMS_BASE_URL, '/catalog');
  const signInUrl = config.LOGIN_URL || indigoGetUrl(config.LMS_BASE_URL, '/login');
  const registerUrl = indigoGetUrl(config.LMS_BASE_URL, '/register');
  const authenticatedMenuItems = [
    {
      id: 'Dashboard',
      type: 'item',
      href: dashboardUrl,
      content: intl.formatMessage(indigoMobileHeaderMessages.dashboard),
    },
    {
      id: 'Catalog',
      type: 'item',
      href: catalogUrl,
      content: intl.formatMessage(indigoMobileHeaderMessages.courses),
    },
    {
      id: 'Profile',
      type: 'item',
      href: `${config.ACCOUNT_PROFILE_URL}/u/${username}`,
      content: intl.formatMessage(indigoMobileHeaderMessages.profile),
    },
    {
      id: 'Account',
      type: 'item',
      href: config.ACCOUNT_SETTINGS_URL,
      content: intl.formatMessage(indigoMobileHeaderMessages.account),
    },
    {
      id: 'Logout',
      type: 'item',
      href: config.LOGOUT_URL,
      content: intl.formatMessage(indigoMobileHeaderMessages.logout),
    },
  ];
  const unauthenticatedMenuItems = [
    {
      id: 'Sign in',
      type: 'item',
      href: signInUrl,
      content: intl.formatMessage(indigoMobileHeaderMessages.signIn),
    },
    {
      id: 'Register',
      type: 'item',
      href: registerUrl,
      content: intl.formatMessage(indigoMobileHeaderMessages.register),
    },
  ];
  const menuItems = isLoggedIn ? authenticatedMenuItems : unauthenticatedMenuItems;

  return (
    <Container className="mobile-header-wrapper" fluid size="xl">
      <div className="mobile-header">
        <Navbar collapseOnSelect expand="lg">
          <Navbar.Brand as="div">
            <IndigoHeaderLogo />
          </Navbar.Brand>
          <div className="mobile-header__actions d-flex align-items-center">
            {isLoggedIn && <NotificationsSlot />}
            <Navbar.Toggle aria-controls="mobile-header-navigation" />
          </div>
          <Navbar.Collapse id="mobile-header-navigation">
            <SecondaryMenuSlot menu={[]} />
            <Nav aria-label="Account" className="mobile-header__navigation">
              <UserMenuSlot menu={[{ items: menuItems }]} />
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    </Container>
  );
};const useIndigoHeaderProps = () => {
  const authenticatedUser = getAuthenticatedUser();
  return {
    isLoggedIn: authenticatedUser !== null,
    username: authenticatedUser?.username || 'Account',
  };
};

const IndigoHeader = ({
  DesktopMenuSlot = DesktopUserMenuSlot,
  MobileMenuSlot = MobileUserMenuSlot,
  MobileSecondaryMenuSlotComponent = MobileSecondaryMenuSlot,
  NotificationsSlot = IndigoHeaderNotificationsSlot,
  DesktopNotificationsSlot = NotificationsSlot,
  MobileNotificationsSlot = NotificationsSlot,
  SecondaryMenuSlot = DesktopSecondaryMenuSlot,
}) => {
  const headerProps = useIndigoHeaderProps();
  const { width } = useWindowSize();

  if (width === undefined) {
    return null;
  }

  return width < breakpoints.medium.minWidth ? (
    <IndigoMobileHeader
      {...headerProps}
      NotificationsSlot={MobileNotificationsSlot}
      SecondaryMenuSlot={MobileSecondaryMenuSlotComponent}
      UserMenuSlot={MobileMenuSlot}
    />
  ) : (
    <IndigoDesktopHeader
      {...headerProps}
      NotificationsSlot={DesktopNotificationsSlot}
      SecondaryMenuSlot={SecondaryMenuSlot}
      UserMenuSlot={DesktopMenuSlot}
    />
  );
};

const IndigoFrontendBaseHeader = () => (
  <IndigoHeader
    DesktopMenuSlot={FrontendBaseDesktopUserMenuSlot}
    MobileMenuSlot={FrontendBaseMobileUserMenuSlot}
    MobileSecondaryMenuSlotComponent={FrontendBaseMobileSecondaryMenuSlot}
    SecondaryMenuSlot={FrontendBaseDesktopSecondaryMenuSlot}
  />
);const welcomeBannerMessages = defineMessages({
  greeting: {
    id: 'learnerDashboard.welcomeBanner.greeting',
    defaultMessage: 'Welcome!',
    description: "Greeting displayed above the learner's name on the dashboard.",
  },
});

const WelcomeBanner = () => {
  const intl = useIntl();
  const authenticatedUser = getAuthenticatedUser();
  const displayName = authenticatedUser?.username || authenticatedUser?.name;

  return (
    <Container className="welcome-banner" fluid size="xl">
      <div className="welcome-banner__eyebrow">
        {intl.formatMessage(welcomeBannerMessages.greeting)}
      </div>
      {displayName && <h1 className="welcome-banner__title">{displayName}</h1>}
    </Container>
  );
};const allCoursesMessages = defineMessages({
  activeCourses: {
    id: 'learnerDashboard.courseList.activeCourses',
    defaultMessage: 'Active courses',
  },
  completedCourses: {
    id: 'learnerDashboard.courseList.completedCourses',
    defaultMessage: 'Completed courses',
  },
  noActiveCourses: {
    id: 'learnerDashboard.courseList.noActiveCourses',
    defaultMessage: "You don't have any active courses.",
  },
  noCompletedCourses: {
    id: 'learnerDashboard.courseList.noCompletedCourses',
    defaultMessage: "You don't have any completed courses.",
  },
});

const getAllCoursesStatusFromHash = () => (
  window.location.hash === '#completed' ? 'completed' : 'active'
);

const AllCourses = ({ courseListData, CourseCard }) => {
  const { formatMessage } = useIntl();
  const { visibleList } = courseListData;
  const [activeCourseStatus, setActiveCourseStatus] = useState(getAllCoursesStatusFromHash);
  const courses = visibleList.filter(({ courseRun }) => (
    activeCourseStatus === 'completed'
      ? courseRun?.isCompleted
      : !courseRun?.isCompleted
  ));

  useEffect(() => {
    const handleHashChange = () => setActiveCourseStatus(getAllCoursesStatusFromHash());
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <Container
      fluid
      size="xl"
      style={ { marginTop: 'var(--pgn-spacing-spacer-4)' }}
    >
      <div className="learner-dashboard-course-list__header">
        <Nav
          variant="tabs"
          activeKey={activeCourseStatus}
          aria-label="Course status"
          onSelect={setActiveCourseStatus}
        >
          <Nav.Item>
            <Nav.Link eventKey="active" href="#active">
              {formatMessage(allCoursesMessages.activeCourses)}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="completed" href="#completed">
              {formatMessage(allCoursesMessages.completedCourses)}
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
      <div className="d-flex flex-column flex-grow-1">
        {courses.length === 0 ? (
          <div className="learner-dashboard-course-list__empty" role="status">
            <Icon
              className="learner-dashboard-course-list__empty-icon"
              src={activeCourseStatus === 'completed' ? CheckCircleOutline : BookOpen}
            />
            <p className="learner-dashboard-course-list__empty-message">
              {formatMessage(
                activeCourseStatus === 'completed'
                  ? allCoursesMessages.noCompletedCourses
                  : allCoursesMessages.noActiveCourses,
              )}
            </p>
          </div>
        ) : (
          courses.map(({ cardId }) => (
            <CourseCard key={cardId} cardId={cardId} />
          ))
        )}
      </div>
    </Container>
  );
};const catalogPageBannerMessages = defineMessages({
  eyebrow: {
    id: 'catalog.page-banner.eyebrow',
    defaultMessage: 'Professional skills & training',
    description: 'Eyebrow text displayed above the catalog page banner heading.',
  },
  heading: {
    id: 'catalog.page-banner.heading',
    defaultMessage: 'Expert-Led Practical Training',
    description: 'Main heading displayed in the catalog page banner.',
  },
  description: {
    id: 'catalog.page-banner.description',
    defaultMessage: 'Gain actionable skills through flexible courses tailored to the demands of your modern workplace.',
    description: 'Supporting text displayed in the catalog page banner.',
  },
  registerButton: {
    id: 'catalog.page-banner.register-button',
    defaultMessage: 'Register now',
    description: 'Label for the catalog page banner registration button.',
  },
  coursesButton: {
    id: 'catalog.page-banner.courses-button',
    defaultMessage: 'Discover our courses',
    description: 'Label for the catalog page banner courses button.',
  },
});

const CatalogPageBanner = () => {
  const intl = useIntl();

  return (
    <Container fluid size="xl" className="catalog-page-banner">
      <div className="catalog-page-banner__content">
        <p className="small text-uppercase font-weight-bold mb-3">
          {intl.formatMessage(catalogPageBannerMessages.eyebrow)}
        </p>
        <h1 className="display-1 font-weight-bold mb-4">
          {intl.formatMessage(catalogPageBannerMessages.heading)}
        </h1>
        <p className="lead mb-5">{intl.formatMessage(catalogPageBannerMessages.description)}</p>
        <div className="catalog-page-banner__actions d-flex flex-wrap">
          <Button
            as="a"
            href={`${getConfig().LMS_BASE_URL}/register`}
            size="lg"
            variant="primary"
          >
            {intl.formatMessage(catalogPageBannerMessages.registerButton)}
          </Button>
          <Button
            href={`${getConfig().LMS_BASE_URL}/courses`}
            size="lg"
            variant="brand"
          >
            {intl.formatMessage(catalogPageBannerMessages.coursesButton)}
          </Button>
        </div>
      </div>
    </Container>
  );
};const catalogHomeCoursesListMessages = defineMessages({
  heading: {
    id: 'catalog.home-courses-list.heading',
    defaultMessage: 'Explore Our Course Catalog',
    description: 'Heading displayed above the catalog home page course list.',
  },
  description: {
    id: 'catalog.home-courses-list.description',
    defaultMessage: 'Gain market-relevant skills through interactive, self-paced learning paths designed to accelerate your technical growth and practical know-how.',
    description: 'Supporting text displayed above the catalog home page course list.',
  },
  coursesLink: {
    id: 'catalog.home-courses-list.courses-link',
    defaultMessage: 'See all courses',
    description: 'Link to the full catalog course list.',
  },
});

const CatalogHomeCoursesListHeader = () => {
  const intl = useIntl();

  return (
    <Container fluid size="xl" className="home-courses-list-header">
      <div>
        <h2 className="h2 mb-2">{intl.formatMessage(catalogHomeCoursesListMessages.heading)}</h2>
        <p className="mb-0">{intl.formatMessage(catalogHomeCoursesListMessages.description)}</p>
      </div>
      <Hyperlink destination={`${getConfig().LMS_BASE_URL}/courses`}>
        {intl.formatMessage(catalogHomeCoursesListMessages.coursesLink)} <span aria-hidden="true">›</span>
      </Hyperlink>
    </Container>
  );
};const catalogCardMessages = defineMessages({
  startDate: {
    id: 'generic.course-card.start-date',
    defaultMessage: 'Starts: {startDate}',
    description: 'Start date.',
  },
});

const getFullImageUrl = path => (path ? `${getConfig().LMS_BASE_URL}${path}` : '');

const getStartDateDisplay = ({ start, advertisedStart }, intl) => (
  advertisedStart || (start ? intl.formatDate(new Date(start), {
    month: 'short', day: 'numeric', year: 'numeric',
  }) : '')
);

const CatalogCourseCard = ({
  isLoading,
  courseId,
  courseOrg,
  courseName,
  courseNumber,
  courseImageUrl,
  courseStartDate,
  courseAdvertisedStart,
}) => {
  const intl = useIntl();
  const isExtraSmall = useMediaQuery({ maxWidth: breakpoints.small.maxWidth });
  const isCatalogMfe = window.location.pathname.startsWith('/catalog');
  const courseAboutPath = `/courses/${courseId}/about`;
  const cardLinkProps = courseId
    ? isCatalogMfe
      ? { as: Link, to: courseAboutPath }
      : { as: 'a', href: `${getConfig().LMS_BASE_URL}${courseAboutPath}` }
    : { as: 'div' };
  const startDateDisplay = (courseStartDate || courseAdvertisedStart) ? getStartDateDisplay({
    start: courseStartDate,
    advertisedStart: courseAdvertisedStart,
  }, intl) : null;

  return (
    <Card
      {...cardLinkProps}
      className={`course-card d-flex ${isExtraSmall ? 'w-100' : 'course-card-desktop'}`}
      isClickable={!isLoading}
      isLoading={isLoading}
      data-testid="course-card"
    >
      {courseImageUrl || isLoading ? (
        <Card.ImageCap
          src={getFullImageUrl(courseImageUrl)}
          srcAlt={`${courseName} ${courseNumber}`}
          skeletonDuringImageLoad
        />
      ) : (
        <div className="course-card__image-fallback" />
      )}
      <Card.Header
        title={courseName}
        subtitle={(
          <>
            <div>{courseNumber}</div>
            <Badge variant="light">{courseOrg}</Badge>
          </>
        )}
        size="sm"
      />
      <Card.Section />
      <Card.Footer
        textElement={startDateDisplay && intl.formatMessage(catalogCardMessages.startDate, {
          startDate: startDateDisplay,
        })}
      />
    </Card>
  );
};const learnerDashboardCourseListMessages = defineMessages({
  activeCourses: {
    id: 'learnerDashboard.courseList.activeCourses',
    defaultMessage: 'Active courses',
  },
  completedCourses: {
    id: 'learnerDashboard.courseList.completedCourses',
    defaultMessage: 'Completed courses',
  },
  allCourses: {
    id: 'learnerDashboard.courseList.allCourses',
    defaultMessage: 'All courses',
  },
  noActiveCourses: {
    id: 'learnerDashboard.courseList.noActiveCourses',
    defaultMessage: "You don't have any active courses.",
  },
  noCompletedCourses: {
    id: 'learnerDashboard.courseList.noCompletedCourses',
    defaultMessage: "You don't have any completed courses.",
  },
});

const getLearnerDashboardCourseStatusFromHash = () => (
  window.location.hash === '#completed' ? 'completed' : 'active'
);

const CourseList = ({ courseListData, CourseCard }) => {
  const { formatMessage } = useIntl();
  const { visibleList } = courseListData;
  const [activeCourseStatus, setActiveCourseStatus] = useState(
    getLearnerDashboardCourseStatusFromHash,
  );
  const courses = visibleList.filter(({ courseRun }) => (
    activeCourseStatus === 'completed'
      ? courseRun?.isCompleted
      : !courseRun?.isCompleted
  )).slice(0, 6);

  useEffect(() => {
    const handleHashChange = () => setActiveCourseStatus(getLearnerDashboardCourseStatusFromHash());
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <>
      <div className="learner-dashboard-course-list__header">
        <Nav
          variant="tabs"
          activeKey={activeCourseStatus}
          aria-label="Course status"
          onSelect={setActiveCourseStatus}
        >
          <Nav.Item>
            <Nav.Link eventKey="active" href="#active">
              {formatMessage(learnerDashboardCourseListMessages.activeCourses)}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="completed" href="#completed">
              {formatMessage(learnerDashboardCourseListMessages.completedCourses)}
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Hyperlink
          as={Link}
          className="learner-dashboard-course-list__all-courses"
          to="/all-courses"
        >
          {formatMessage(learnerDashboardCourseListMessages.allCourses)}{' '}
          <span aria-hidden="true">›</span>
        </Hyperlink>
      </div>
      <div className="d-flex flex-column flex-grow-1">
        {courses.length === 0 ? (
          <div className="learner-dashboard-course-list__empty" role="status">
            <Icon
              className="learner-dashboard-course-list__empty-icon"
              src={activeCourseStatus === 'completed' ? CheckCircleOutline : BookOpen}
            />
            <p className="learner-dashboard-course-list__empty-message">
              {formatMessage(
                activeCourseStatus === 'completed'
                  ? learnerDashboardCourseListMessages.noCompletedCourses
                  : learnerDashboardCourseListMessages.noActiveCourses,
              )}
            </p>
          </div>
        ) : (
          courses.map(({ cardId }) => (
            <CourseCard key={cardId} cardId={cardId} />
          ))
        )}
      </div>
    </>
  );
};const courseRecommendationsMessages = defineMessages({
  heading: {
    id: 'learnerDashboard.courseRecommendations.heading',
    defaultMessage: 'Discover more courses!',
  },
  showAllCourses: {
    id: 'learnerDashboard.courseRecommendations.showAllCourses',
    defaultMessage: 'Show all courses',
  },
});

const getLatestCoursesUrl = () => (
  `${getConfig().LMS_BASE_URL}/api/courses/v1/courses/latest/`
);

const transformRecommendedCourse = (course) => ({
  courseId: course.id,
  courseOrg: course.org,
  courseName: course.name,
  courseNumber: course.number,
  courseImageUrl: course.media?.course_image?.uri,
  courseStartDate: course.start,
  courseAdvertisedStart: course.start_display,
});

const CourseRecommendations = () => {
  const { formatMessage } = useIntl();
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    getAuthenticatedHttpClient().get(getLatestCoursesUrl())
      .then(({ data }) => {
        if (isMounted) {
          setCourses((data.results || []).map(transformRecommendedCourse));
        }
      })
      .catch(() => {
        if (isMounted) {
          setCourses([]);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const visibleCourses = courses.slice(0, 3);

  return (
    <div className="learner-dashboard-course-recommendations">
      <div className="learner-dashboard-course-list__header">
        <h2 className="h3 mb-0">{formatMessage(courseRecommendationsMessages.heading)}</h2>
        <Hyperlink
          as={Link}
          className="learner-dashboard-course-list__all-courses"
          to={`${getConfig().LMS_BASE_URL}/courses`}
        >
          {formatMessage(courseRecommendationsMessages.showAllCourses)}{' '}
          <span aria-hidden="true">›</span>
        </Hyperlink>
      </div>

      <CardGrid columnSizes={ {
        xs: 12,
        md: 6,
        lg: 4,
        xl: 4,
      }}
      >
        {isLoading
          ? Array.from({ length: 3 }, (_, index) => (
            <CatalogCourseCard key={`loading-${index}`} isLoading />
          ))
          : visibleCourses.map((course) => (
            <CatalogCourseCard key={course.courseId} isLoading={false} {...course} />
          ))}
      </CardGrid>
    </div>
  );
};const Courses = ({ courseListData, CourseCard }) => (
  <>
    <CourseList courseListData={courseListData} CourseCard={CourseCard} />
    <div className="mt-5">
      <CourseRecommendations />
    </div>
  </>
);
  addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
    {
        op: PLUGIN_OPERATIONS.Hide,
        widgetId: 'default_contents',
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'indigo_footer',
            type: DIRECT_PLUGIN,
            priority: 1,
            RenderWidget: Footer,
        },
    },
]);
  addPlugins(config, 'org.openedx.frontend.layout.header_desktop.v1', [
    {
        op: PLUGIN_OPERATIONS.Hide,
        widgetId: 'default_contents',
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'indigo_desktop_header',
            type: DIRECT_PLUGIN,
            priority: 1,
            RenderWidget: IndigoFrontendBaseHeader,
        },
    },
]);
  addPlugins(config, 'org.openedx.frontend.layout.header_mobile.v1', [
    {
        op: PLUGIN_OPERATIONS.Hide,
        widgetId: 'default_contents',
    },
]);
  addPlugins(config, 'logo_slot', [
    {
        op: PLUGIN_OPERATIONS.Hide,
        widgetId: 'default_contents',
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'custom_logo',
            type: DIRECT_PLUGIN,
            RenderWidget: ThemedLogo,
        }
    }
]);
if (config.pluginSlots && config.pluginSlots['logo_slot']) {
  config.pluginSlots['logo_slot'].keepDefault = false;

  const logoInsertPlugins =
    config.pluginSlots['logo_slot'].plugins.filter(plugin => plugin.op === 'insert' && plugin.widget?.id === 'custom_logo');

  if (logoInsertPlugins.length > 1) {
    let kept = false;
    config.pluginSlots['logo_slot'].plugins =
      config.pluginSlots['logo_slot'].plugins.filter(plugin => {
        if (plugin.op === 'insert' && plugin.widget?.id === 'custom_logo') {
          if (kept) return false;
          kept = true;
        }
        return true;
      });
  }
}

if (config.pluginSlots && config.pluginSlots['org.openedx.frontend.layout.footer.v1']) {
  const seenIndigoFooterWidgets = new Set();

  config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins =
    config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins.filter(plugin => {
      if (plugin.op !== 'insert') {
        return true;
      }

      const widgetId = plugin.widget?.id;
      if (!['indigo_footer', 'read_theme_cookie'].includes(widgetId)) {
        return true;
      }

      if (seenIndigoFooterWidgets.has(widgetId)) {
        return false;
      }

      seenIndigoFooterWidgets.add(widgetId);
      return true;
    });
}

  return config;
}

export default setConfig;